import { useEffect, useCallback, useRef } from 'react';
import { TransformWrapper, TransformComponent, useControls, useTransformEffect } from 'react-zoom-pan-pinch';
import { useDispatch } from 'react-redux';
import { transactionActions } from 'store/transactionsSlice/transactionsSlice';
import { defaultTransformWrapperConfig } from '../config';

function DigitalZoom({ children, reset }) {
    const dispatch = useDispatch();
    const { resetTransform } = useControls();

    const prevZoomedRef = useRef(false);

    const handleIsImageZoomed = useCallback(
        (scale) => {
            if (reset) return;
            if (scale > 1 && !prevZoomedRef.current) {
                dispatch(transactionActions.setImageIsDigitalZoomed(true));
                prevZoomedRef.current = true;
            } else if (scale === 1 && prevZoomedRef.current) {
                dispatch(transactionActions.setImageIsDigitalZoomed(false));
                prevZoomedRef.current = false;
            }
        },
        [dispatch, reset]
    );

    useTransformEffect(({ state }) => {
        handleIsImageZoomed(state.scale);
    });

    useEffect(() => {
        if (reset) resetTransform();
        // eslint-disable-next-line
    }, [reset]);
    return (
        <TransformComponent
            wrapperStyle={{
                width: '100%',
                height: '100%',
                aspectRatio: '16/9',
            }}
            contentStyle={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            {children}
        </TransformComponent>
    );
}

export default function DigitalZoomWraper({ children, config, ...rest }) {
    return (
        <TransformWrapper {...defaultTransformWrapperConfig} {...config}>
            <DigitalZoom {...rest}>{children}</DigitalZoom>
        </TransformWrapper>
    );
}
